import type { VariableValueInput } from '~/server/api/routers/variable';

export function getVariableValue(variableValue: VariableValueInput) {
  return (
    variableValue === null ? 'null'
    : variableValue === false ? 'false'
    : typeof variableValue === 'string' ? variableValue.replace(/^['"]|['"]$/g, '')
    : JSON.stringify(variableValue)
  );
}

export function getSensitiveValue(value: VariableValueInput): string | Record<string, VariableValueInput> {
  const valueType = typeof value;
  if (valueType === 'object' && value !== null) {
    // Get type of each property
    return Object.fromEntries(Object.entries(value).map(([key, val]) => [key, getSensitiveValue(val)]));
  }
  return '';
}
